import { fromJS } from 'immutable';
import * as constants from './constants';


//初始化数据
const defaultState = fromJS({
    
    orgDeviceTree: [],  //左测导航树数据 

    patchTypeList: [],  //采集点类型列表 

    orgBreadCrumbs: {
        breadCrumbs: [],  //列表
        device: {}  //当前像
    },  //左测导航树数据 点击缓存数据
});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
    switch (action.type) {
        //设备树
        case constants.ORG_DEVICE_DATA:
            return state.set('orgDeviceTree', action.data);
        //设备树
        case constants.PATCH_TYPE_DATAS:
            return state.set('patchTypeList', action.data);
        //设备树 - 点击事件缓存数据
        case constants.ORG_BREAD_CRUMBS:
            return state.set('orgBreadCrumbs', action.data);

        default:
            return state;
    }
};
